import { RouteItem } from '@eastcoal/router/types/route'

import {
  NOTICE_DETAIL_PAGE_PATH,
  NOTICE_LIST_PAGE_PATH
} from './constants/path'

export const noticeRoute: RouteItem = {
  title: '网站公告',
  hideInMenu: true,
  children: [
    {
      title: '列表',
      path: NOTICE_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '详情',
      path: NOTICE_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    }
  ]
}
